import { isValid, parseISO, formatDate } from 'date-fns';

const formatDateIfValid = (dateInput: string | Date, format: string) => {
    let date;

    if (typeof dateInput === 'string') {
        date = parseISO(dateInput);
    } else if (dateInput instanceof Date) {
        date = dateInput;
    } else {
        return '';
    }

    return isValid(date) ? formatDate(date, format) : '';
};

const toUSD = (amount: number | string | null | undefined) => {
    // Coerce to a finite number first
    let num: number;
    if (typeof amount === 'number') {
        num = amount;
    } else if (typeof amount === 'string') {
        const cleaned = amount.replace(/[\s,\$]/g, '');
        num = Number(cleaned);
    } else {
        num = NaN;
    }

    if (!isFinite(num)) return '';
    if (num === 0) return '$0.00';

    try {
        return num.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    } catch {
        return '';
    }
};

const currencyConfig = {
    locale: 'en-US',
    formats: {
        number: {
            USD: {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            },
        },
    },
};

const handleResponse = async (resp: Response) => {
    const json = await resp.json();
    if (!resp.ok) {
        const error: any = new Error(json.error || 'API request failed');
        error.response = { status: resp.status };
        error.data = json;
        throw error;
    }
    return json;
};

export { formatDateIfValid, toUSD, currencyConfig, handleResponse };
